<template>
    <tailwind-layout title="Maintenance Property Vendors">
        <template #header>
            <div class="px-4 sm:px-6 lg:px-8 mx-auto hidden lg:flex justify-between items-center"><!-- Block for lg and larger -->
                <div class="flex flex-col">
                    <h1 class="font-semibold text-2xl leading-tight">Maintenance Property Vendors</h1>
                    <h2 class="text-xs">Add Approved Vendors to begin managing maintenence properties.</h2>
                </div>
                <div class="flex items-center space-x-4">
                    <inertia-link :href="route('maintenance.index')"
                        class="mt-1 relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">
                        <font-awesome-icon :icon="faChevronLeft" class="h-5 w-5 text-gray-400" aria-hidden="true" /> Back
                    </inertia-link>
                    <button @click="openAddModal" class="primaryButton">
                        Add New Vendor
                    </button>
                </div>
            </div>

            <div class="mb-3 px-6 lg:px-8 mx-auto flex flex-col lg:hidden"><!-- Block for sm, md, lg (buttons will stack on smaller screens) -->
                <div class="flex justify-between items-start md:items-center">
                    <div class="flex flex-col">
                        <h1 class="font-semibold text-2xl leading-tight">Maintenance Property Vendors</h1>
                        <h2 class="text-xs">Add Approved Vendors to begin managing maintenence properties.</h2>
                    </div>
                    <button @click="openAddModal" class="primaryButton">
                        Add New Vendor
                    </button>
                </div>
            </div>
        </template>
        <div class="overflow-hidden">
            <div class="relative">
                <div class="grid grid-cols-3 sm:grid-cols-2 gap-4 mb-6 sm:flex sm:justify-items-stretch ml-2 lg:ml-0">
                    <div class="w-full sm:w-2/12 pr-4 order-2 sm:order-1">
                        <select v-model="form.paginate" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-100 drop-shadow focus:outline-none focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 sm:text-sm rounded-md" aria-label="Number of Vendors per page">
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div class="col-span-3 sm:w-6/12 sm:pr-4 order-1 sm:order-2 px-2">
                        <input id="search" v-model="form.search" type="text" placeholder="Search for Vendors..." class="mt-1 shadow-sm focus:ring-rent-risk-blue-400 focus:border-rent-risk-blue-400 block w-full sm:text-sm border-gray-100 drop-shadow rounded-md sm:mx-2">
                        <div class="flex items-center mt-2 md:ml-2" @click="show_archived_vendors()">
                            <SwitchGroup as="div" class="flex items-center" v-model="form.trashed">
                                <Switch :class="[form.trashed ? 'bg-rent-risk-blue-400' : 'bg-gray-200', 'relative inline-flex h-4 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-rent-risk-blue-400 focus:ring-offset-2']">
                                    <span aria-hidden="true" :class="[form.trashed ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block size-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
                                </Switch>
                                <SwitchLabel as="span" class="ml-3 text-sm">
                                    <span class="font-medium text-gray-700">Show Archived Vendors</span>
                                </SwitchLabel>
                            </SwitchGroup>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rounded-md lg:shadow shadow-none overflow-x-auto">
                <div class="flex flex-col">
                    <div class="overflow-x-auto">
                        <div class="align-middle inline-block min-w-full">
                            <div class="shadow overflow-hidden lg:border">
                                <input ref="sort_by" type="hidden" v-model="form.sort_by" />
                                <input ref="sort_direction" type="hidden" v-model="form.sort_direction" />
                                <table class="min-w-full divide-y divide-gray-300 hidden lg:table">
                                    <thead class="bg-blue-50">
                                    <tr>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">
                                            Name 
                                        </th>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-right">
                                            <span>
                                                Office Phone 
                                            </span>
                                        </th>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-right">
                                            <span>
                                                Cell Phone 
                                            </span>
                                        </th>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-right">
                                            Email
                                        </th>
                                       
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-right">
                                            Actions
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody class="divide-y divide-gray-200">
                                    <tr v-for="(vendor, index) in vendors.data" :key="index"
                                           :class="[(index % 2 === 0 && !vendor.deleted_at ? 'bg-gray-50 border-b hover:bg-yellow-50 hover:cursor-pointer' : (!vendor.deleted_at) ? 'bg-white border-b hover:bg-yellow-50 hover:cursor-pointer' : ''),
                                        (vendor.deleted_at ? 'bg-red-100 !border-b !border-red-200 hover:bg-red-200 hover:cursor-pointer' : '')]"
                                    >
                                        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                            {{ vendor.name }}
                                        </td>
                                        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-right">
                                            {{ vendor.office_phone }}
                                        </td>
                                        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-right">
                                            {{ vendor.office_phone }}
                                        </td>
                                        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-right">
                                            {{ vendor.email }}
                                        </td>
                                        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-right">
                                            <button v-if="vendor.deleted_at" @click="openRestoreModal(vendor)"
                                                class="bg-blue-50 px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-gray-300 hover:bg-blue-200 rounded-md">
                                                Restore
                                            </button> 
                                            <button v-if="!vendor.deleted_at"  @click="openEditModal(vendor)"  class="relative -ml-px inline-flex items-center bg-blue-50 px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-blue-200 focus:z-10">
                                                Edit
                                            </button>
                                            <button v-if="!vendor.deleted_at" @click="openDeleteModal(vendor)"  class="relative -ml-px inline-flex items-center bg-blue-50 px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-blue-200 focus:z-10">
                                                Archive
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-show="!vendors.data.length">
                                        <td colspan="5" class="px-6 py-4 whitespace-nowrap text-dark-gray-400 text-sm font-medium text-center">
                                            No Vendors were found.
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <!-- Stacked layout for sm, md, and lg (table becomes vertical) -->
                                <ul role="list" class="lg:hidden grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 my-5 px-2">
                                    <li v-for="(vendor, index) in vendors.data" :key="index" :class="[vendor.deleted_at ? 'bg-red-100 hover:bg-red-50 hover:outline-red-500 divide-red-300' : 'bg-white hover:outline-blue-500 hover:bg-blue-50 divide-gray-200', 'col-span-1 divide-y rounded-lg shadow-lg hover:outline hover:outline-offset-2 border']">
                                        <div class="flex flex-col p-6">
                                            <h3 class="truncate text-sm font-medium text-gray-900">{{ vendor.name }}</h3>
                                            <h4 class="mt-1 truncate text-sm text-gray-500"><span class="text-gray-900">Name:</span> {{ vendor.name }}</h4>
                                            <h4 class="mt-1 truncate text-sm text-gray-500"><span class="text-gray-900">Office Phone:</span> {{ vendor.office_phone }}</h4>
                                            <h4 class="mt-1 truncate text-sm text-gray-500"><span class="text-gray-900">Cell Phone:</span> {{ vendor.cell_phone }}</h4>
                                            <h4 class="mt-1 truncate text-sm text-gray-500"><span class="text-gray-900">Email:</span> {{ vendor.email }}</h4>
                                        </div>
                                        <div>
                                            <div :class="[vendor.deleted_at ? 'divide-red-300' : 'divide-gray-200','-mt-px flex divide-x']">
                                                <div class="-ml-px flex w-0 flex-1">
                                                    <button v-if="vendor.deleted_at" @click="openEditModal(vendor)" class="bg-blue-50 px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-gray-300 hover:bg-blue-200 rounded-md">
                                                        Restore
                                                    </button>
                                                    <button v-if="!vendor.deleted_at" @click="openEditModal(vendor)" class="bg-blue-50 px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-gray-300 hover:bg-blue-200 rounded-md">
                                                        Edit
                                                    </button>
                                                    <button v-if="!vendor.deleted_at" @click="openDeleteModal(vendor)" class="ml-2 bg-red-50 px-3 py-2 text-sm font-semibold text-red-600 ring-1 ring-red-300 hover:bg-red-200 rounded-md">
                                                        Archive
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <pagination class="mt-6" :links="vendors.links" :results="vendors" :type="'vendors'" />

            <!-- Delete Confirmation Modal -->
            <div v-if="showDeleteModal">
                <TransitionRoot as="template" :show="showDeleteModal">
                    <Dialog as="div" class="relative z-10" @close="showDeleteModal = false">
                        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </TransitionChild>

                        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                            <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                                    <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-6 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                                        <div class="text-center sm:text-left">
                                            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
                                                <font-awesome-icon :icon="faBoxArchive" class="h-6 w-6 text-red-500" aria-hidden="true" />
                                            </div>
                                            <div class="mt-2">
                                                <p class="text-sm text-center sm:mt-5">
                                                    Are you sure you want to archive "<strong>{{ selectedVendor.name }}</strong>"? 
                                                </p>
                                            </div>
                                        </div>

                                        <div class="mt-5 sm:mt-6 flex">
                                            <button type="button" class="w-1/2 mr-1 justify-center rounded-md bg-gray-50 border-gray-400 px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-200 focus:outline-none" @click="showDeleteModal = false">
                                                Cancel
                                            </button>
                                            <button type="button" class="flex-shrink-0 w-1/2 ml-1 justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" @click="deleteVendor">
                                                Confirm
                                            </button>
                                        </div>
                                    </DialogPanel>
                                </TransitionChild>
                            </div>
                        </div>
                    </Dialog>
                </TransitionRoot>
            </div>

            <!-- Vendor Modal (Used for Add & Edit) -->
            <div v-if="showVendorModal">
                <TransitionRoot as="template" :show="showVendorModal">
                    <Dialog as="div" class="relative z-10" @close="closeVendorModal">
                        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </TransitionChild>

                        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                            <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                                    <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-6 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                        <div class="text-center sm:text-left">
                                            <DialogTitle as="h3" class="text-lg font-semibold text-gray-900">
                                                {{ isEditing ? 'Edit Vendor' : 'Add New Vendor' }}
                                            </DialogTitle>
                                            <div class="mt-2">
                                        
                                                <label for="vendor_name" :class="errors.name ? 'block text-sm font-medium text-red-500' : 'block text-sm font-medium text-gray-700'">
                                                    Vendor Name
                                                </label>
                                                <input id="vendor_name" type="text" v-model="vendorForm.name"
                                                    :class="errors.name ? 'mt-1 w-full border-red-300 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 sm:text-sm' : 'mt-1 w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'">
                                                <p v-if="errors.name" class="text-red-500 text-sm">{{ errors.name }}</p>

                                                <label for="office_phone" :class="errors.office_phone ? 'block text-sm font-medium text-red-500 mt-3' : 'block text-sm font-medium text-gray-700 mt-3'">
                                                    Office Phone
                                                </label>
                                                <input id="office_phone" type="text" v-model="vendorForm.office_phone"
                                                    :class="errors.office_phone ? 'mt-1 w-full border-red-300 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 sm:text-sm' : 'mt-1 w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'">
                                                <p v-if="errors.office_phone" class="text-red-500 text-sm">{{ errors.office_phone }}</p>

                                                <label for="cell_phone" :class="errors.cell_phone ? 'block text-sm font-medium text-red-500 mt-3' : 'block text-sm font-medium text-gray-700 mt-3'">
                                                    Cell Phone
                                                </label>
                                                <input id="cell_phone" type="text" v-model="vendorForm.cell_phone"
                                                    :class="errors.cell_phone ? 'mt-1 w-full border-red-300 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 sm:text-sm' : 'mt-1 w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'">
                                                <p v-if="errors.cell_phone" class="text-red-500 text-sm">{{ errors.cell_phone }}</p>

                                                <label for="email" :class="errors.email ? 'block text-sm font-medium text-red-500 mt-3' : 'block text-sm font-medium text-gray-700 mt-3'">
                                                    Email
                                                </label>
                                                <input id="email" type="email" v-model="vendorForm.email"
                                                    :class="errors.email ? 'mt-1 w-full border-red-300 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 sm:text-sm' : 'mt-1 w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'">
                                                <p v-if="errors.email" class="text-red-500 text-sm">{{ errors.email }}</p>

                                                <label for="additional_instructions" :class="errors.additional_instructions ? 'block text-sm font-medium text-red-500 mt-3' : 'block text-sm font-medium text-gray-700 mt-3'">
                                                    Additional Information
                                                </label>
                                                <textarea id="additional_instructions" rows="3" v-model="vendorForm.additional_instructions"
                                                    :class="errors.additional_instructions ? 'mt-1 w-full border-red-300 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 sm:text-sm' : 'mt-1 w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'"
                                                    placeholder="Additional Information">
                                                </textarea>
                                                <p v-if="errors.additional_instructions" class="text-red-500 text-sm">{{ errors.additional_instructions }}</p>

                                            </div>
                                        </div>

                                        <div class="mt-5 sm:mt-6 flex">
                                            <button type="button" class="w-1/2 mr-1 justify-center rounded-md bg-gray-50 border-gray-400 px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-200 focus:outline-none" @click="closeVendorModal">
                                                Cancel
                                            </button>
                                            <button type="button" class="flex-shrink-0 w-1/2 ml-1 justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                @click="saveVendor">
                                                {{ isEditing ? 'Save' : 'Add Vendor' }}
                                            </button>
                                        </div>
                                    </DialogPanel>
                                </TransitionChild>
                            </div>
                        </div>
                    </Dialog>
                </TransitionRoot>
            </div>

            <!-- Restore Vendor Modal  -->
            <div v-if="showRestoreModal">
                <TransitionRoot as="template" :show="showRestoreModal">
                    <Dialog as="div" class="relative z-10" @close="showRestoreModal = false">
                        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </TransitionChild>

                        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                            <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                                    <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                                        <div>
                                            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                                                <font-awesome-icon :icon="faArrowsRotate" class="h-6 w-6 text-green-500" aria-hidden="true" />
                                            </div>
                                            <div class="mt-3 text-center sm:mt-5">
                                                <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Are you sure you want to restore this vendor?</DialogTitle>
                                                <div class="mt-2">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-5 sm:mt-6 flex">
                                            <button type="button" class="flex-shrink-0 w-1/2 mr-1 justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600" @click="showRestoreModal = false">Close</button>
                                            <button type="button" class="flex-shrink-0 w-1/2 ml-1 justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" @click="restoreVendor()">Confirm</button>
                                        </div>
                                    </DialogPanel>
                                </TransitionChild>
                            </div>
                        </div>
                    </Dialog>
                </TransitionRoot>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import Icon from '@/Shared/Icon.vue'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination.vue'
import pickBy from 'lodash/pickBy'
import Button from "@/Jetstream/Button.vue";
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowsRotate, faBoxArchive, faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { router } from '@inertiajs/vue3';

export default {
    components: {
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        FontAwesomeIcon,
        Button,
        Icon,
        Pagination,
        TailwindLayout,
    },
    props: {
        filters: Object,
        vendors: Object,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                trashed: this.filters.trashed,
                paginate: (this.filters.paginate)?this.filters.paginate:100,
                sort_by: this.filters.sort_by,
                sort_direction_icon : (this.filters.sort_direction === 'desc')?'sort-up':'sort-down'
            },
            showVendorModal: false,
            isEditing: false,
            errors: {} ,
            showDeleteModal: false,
            selectedVendor: null,
            showRestoreModal: false,
            vendorToRestore: null,
            vendorForm: {
                id: null,
                name: '',
                office_phone: '',
                cell_phone: '',
                email: '',
                additional_instructions: ''
            },
            faArrowsRotate,
            faChevronLeft,
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function() {
                this.$inertia.get(this.route('vendors.index'), pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        openDeleteModal(vendor) {
            this.selectedVendor = vendor;
            this.showDeleteModal = true;
        },
        deleteVendor() {
            router.delete(route('vendors.destroy', this.selectedVendor.id), {
                onSuccess: () => {
                    this.showDeleteModal = false;
                },
                onError: () => {
                }
            });
        },
        openRestoreModal(vendor) {
            this.vendorToRestore = vendor;
            this.showRestoreModal = true;
        },
        restoreVendor() {
            if (!this.vendorToRestore) return;

            router.put(route('vendors.restore', this.vendorToRestore.id), {}, {
                onSuccess: () => {
                    this.showRestoreModal = false;
                    this.vendorToRestore = null;
                },
                onError: () => {
                }
            });
        },
        openAddModal() {
            this.isEditing = false;
            this.vendorForm = {
                id: null,
                name: '',
                office_phone: '',
                cell_phone: '',
                email: '',
                additional_instructions: ''
            };
            this.errors = {};
            this.showVendorModal = true;
        },
        openEditModal(vendor) {
            this.isEditing = true;
            this.vendorForm = { ...vendor };
            this.errors = {};
            this.showVendorModal = true;
        },
        updateVendor() {
            router.put(route('vendors.update', this.editVendor.id), {
                name: this.editVendor.name,
                office_phone: this.editVendor.office_phone,
                cell_phone: this.editVendor.cell_phone,
                email: this.editVendor.email,
                additional_instructions: this.editVendor.additional_instructions,
            }, {
                onSuccess: () => {
                    this.showEditModal = false;
                    this.errors = {}; 
                },
                onError: (errors) => {
                    this.errors = errors; 
                },
            });
        },
        closeVendorModal() {
            this.showVendorModal = false;
            this.errors = {};
        },
        saveVendor() {
            if (this.isEditing) {
                router.put(route('vendors.update', this.vendorForm.id), this.vendorForm, {
                    onSuccess: () => {
                        this.showVendorModal = false;
                        this.errors = {};
                    },
                    onError: (errors) => {
                        this.errors = errors;
                    }
                });
            } else {
                router.post(route('vendors.store'), this.vendorForm, {
                    onSuccess: () => {
                        this.showVendorModal = false;
                        this.errors = {};
                    },
                    onError: (errors) => {
                        this.errors = errors;
                    }
                });
            }
        },
        show_archived_vendors() {
            this.form.trashed = !this.form.trashed;
        },
        sortTable(column) {
            this.form.sort_by = column
            this.form.sort_direction = (this.form.sort_direction === 'desc')?'asc':'desc'
            this.form.sort_direction_icon = (this.form.sort_direction === 'desc')?'sort-up':'sort-down'
        },
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
